export const TOGGLE_POP = 'population_TOGGLE_BY_IDS_SINGLE'

export const togglePop = data => {
  return {
    type: TOGGLE_POP,
    indexes: data
  }
}

export const SET_POPUP = 'SET_POPUP_POP';

export const setPopup = data => {
	return {
		type: SET_POPUP,
		action: data
	}
}

export const setActive = props => {
  return {
    type: SET_POPUP,
    data: props
  }
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/population/actions.js